import type { HuntsStatusFilter } from '@wehunt/ui'

const KNOWN: readonly HuntsStatusFilter[] = ['all', 'pending', 'upcoming', 'ongoing', 'ended', 'expired']

/**
 * Read the hunts list filter out of the URL.
 *
 * The value is whatever a link or a hand-edited address bar happens to carry,
 * so anything unrecognised falls back to "all" — showing every hunt is a
 * harmless answer to a bad parameter, where trusting it would render an empty
 * list the hunter has no way to explain.
 */
export function huntsFilterFromSearch(raw: string | null | undefined): HuntsStatusFilter {
  return KNOWN.find((f) => f === raw) ?? 'all'
}
